import { EventEmitter, Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
  })
  export class EformsToolsService {


    public propertyNamesToLowercase(obj) {
        function isPlainObject(input) {
          return input && !Array.isArray(input) && typeof input === 'object';
        }
    
        if (Array.isArray(obj)) return obj.map(e => this.propertyNamesToLowercase(e));
        if (!isPlainObject(obj)) return obj;
    
        const final = {};
        // Iterate over key-value pairs of the root object 'obj'
        for (const [key, value] of Object.entries(obj)) {
          // Set the lowercased key in the 'final' object and use the original value if it's not an object
          // else use the value returned by this function (recursive call).
          final[key.toLowerCase()] = this.propertyNamesToLowercase(value);
        }
        return final;
      }

  }